<div class="product-rating">
  <app-trustpilot
    [height]="'40px'"
    [config]="trustpilotConfig"
  ></app-trustpilot>
</div>

<div class="product-close-details">
  <div class="product-close-details-day">
    Competition closes
    <ng-container [ngSwitch]="timeVersion">
      <span *ngSwitchCase="relativeTime.Today">
        Today at {{ endAt | unifyDate | tzDate: hourFormat }}
      </span>
      <span *ngSwitchCase="relativeTime.Tomorrow">
        Tomorrow at {{ endAt | unifyDate | tzDate: hourFormat }}
      </span>
      <span *ngSwitchCase="relativeTime.ThisWeek">
        {{ endAt | unifyDate | tzDate: 'EEEE' }} at
        {{ endAt | unifyDate | tzDate: hourFormat }}
      </span>
      <span *ngSwitchCase="relativeTime.NextWeek">
        next {{ endAt | unifyDate | tzDate: 'EEEE' }} at
        {{ endAt | unifyDate | tzDate: hourFormat }}
      </span>
      <span *ngSwitchDefault>
        on {{ endAt | unifyDate | tzDate: 'dd-MM-yyyy' }} at
        {{ endAt | unifyDate | tzDate: hourFormat }}
      </span>
    </ng-container>
  </div>
  <div class="product-close-details-sold"
    >or when all {{ instantTypeText }} are sold</div
  >
</div>
